import { months } from '@pages/WorkSchedule/data';
import { isLeapYear } from '@pages/WorkSchedule/utils/isLeapYear';
import type { NWorkSchedule } from '@pages/WorkSchedule/WorkSchedule.types';

export const getCellsCountToRender = (
  renderedMonths: NWorkSchedule.RenderedMonths
): number => {
  let result = 0;

  (renderedMonths || []).forEach((date: string) => {
    const [year] = date.split('-');
    const monthId = new Date(date).getMonth();
    const monthInfo = months.find(
      ({ monthId: _monthId }) => _monthId === monthId
    );
    const humanMonthId = monthInfo?.humanMonthId;
    const isFeburary = months.find(
      ({ humanMonthId: _humanMonthId }) => _humanMonthId === humanMonthId
    );

    if (isFeburary) {
      if (isLeapYear(year)) {
        return (result += 29);
      } else {
        return (result += 28);
      }
    } else {
      return (result +=
        monthInfo?.daysInMonth as NWorkSchedule.Month['daysInMonth']);
    }
  });

  return result;
};
